"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PourquoiChoisirBeTravaux() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    title: "Plateforme innovante",
    description: "Facilitant la mise en relation entre particuliers et artisans qualifiés",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/innovative_platform_illustration.png",
    delay: "delay-0"
  }, {
    title: "Devis en ligne immédiat",
    description: "Obtenez rapidement une estimation précise de vos travaux",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/instant_quote_illustration.png",
    delay: "delay-100"
  }, {
    title: "Aides financières",
    description: "Simulation et accompagnement pour vos démarches administratives",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/financial_aid_illustration.png",
    delay: "delay-200"
  }, {
    title: "Interventions rapides",
    description: "Service d'urgence disponible pour vos besoins immédiats",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/emergency_service_illustration.png",
    delay: "delay-300"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  const orangeTitles = ["Plateforme innovante", "Devis en ligne immédiat", "Aides financières", "Interventions rapides"];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Pourquoi choisir Be Travaux ?
          </h2>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto">
            Une plateforme complète pour tous vos projets de rénovation et d'amélioration énergétique
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, i) => <div key={i} data-index={i} ref={refs[i]} className={`relative group transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${visibilities[i] ? `opacity-100 translate-y-0 ${benefit.delay}` : "opacity-0 translate-y-8"} hover:rotate-[2deg] hover:-translate-y-2`}>
              <div className="absolute inset-0 rounded-lg overflow-hidden">
                <img src={benefit.image} alt="" className="w-full h-full object-cover opacity-20" />
              </div>

              <Card className="relative bg-background/90 backdrop-blur-sm border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] h-full">
                <CardHeader>
                  <CardTitle className={`text-xl font-display font-bold ${orangeTitles.includes(benefit.title) ? "text-secondary" : "text-foreground"}`}>
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-foreground/80 text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}